import VersionDetailContainer from './version-detail-container';

export default VersionDetailContainer;
